export default __webpack_public_path__ + "static/media/Rank_top_nav_bar_button.4946ae8f.png";